/**
 * Settings that apply to a store's manager.
 */
export class ManagerSettings {
  startDate: string;
  canDoSales: boolean;

  /**
   * @param startDate the Monday starting from which manager settings take effect.
   * @param canDoSales `true` if manager does sales.
   */
  constructor(startDate: string, canDoSales: boolean) {
    this.startDate = startDate;
    this.canDoSales = canDoSales;
  }
}

